import { css } from 'lit';

export default css`
  :host {
    --_active-color: var(--sl-color-input-option-default-checked-default-background);
    --_gap: 0.25rem;
    --_icon-color: currentcolor;

    display: block;
    inline-size: 100%;
  }

  :host([active]) {
    --_icon-color: var(--_active-color);
  }

  .toggle {
    box-sizing: border-box;
    font-weight: var(--_header-font-weight);
    inline-size: 100%;
    justify-content: space-between;
    padding-inline: var(--_header-padding-inline);
  }

  .toggle sl-icon[name$='filter'] {
    margin-inline-start: auto;
  }

  sl-popover {
    --_padding: 0;

    font-weight: var(--sl-text-typeset-fontWeight-regular);
    padding: 0;
  }

  header {
    align-items: center;
    background: var(--sl-elevation-surface-raised-default);
    border-block-end: 1px solid var(--sl-color-elevation-border-raised);
    display: flex;
    font-weight: var(--sl-font-weight-semibold);
    gap: var(--sl-size-100);
    inset-block-start: calc(var(--sl-size-300) * -1);
    justify-content: space-between;
    margin-block: calc(var(--sl-size-300) * -1) var(--sl-size-200);
    padding-block-start: var(--sl-size-300);
    position: sticky;
    z-index: 1;
  }

  h1 {
    font: var(--sl-text-body-md-demibold);
    margin: 0;
  }
`;
